import { PropsWithTheme, WHITE_100 } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { AdvancedOptions } from './advancedInputs';
import { BasicInputs } from './basicInputs';

const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(4)}px;
    padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
  }
  background-color: ${WHITE_100};
  border-radius: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1, 1)};
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(2)}px;
`;

export const Inputs = () => (
  <InputsWrapper>
    <BasicInputs />
    <AdvancedOptions />
  </InputsWrapper>
);
